export const SMARTCONSENT_CLIENT_ID = 'JcXKFU9ZehZBLWdqGFLNVoMUJHMnoR1i';
export const SMARTCONSENT_DOMAIN = 'smartconsent-dev.us.auth0.com';
export const SMARTCONSENT_AUDIENCE = 'https://smartconsent-dev.us.auth0.com/userinfo';
export const SMARTCONSENT_AUTH_SCOPE = 'openid profile email';
export const SMARTCONSENT_AUTH_CONNECTION_TYPE = 'google-oauth2';
export const IMAGE_URL = 'https://d3p56cllgt1gum.cloudfront.net';
export const ENVIRONMENT = 'uat';
export const FLINKS_DEMO = true;
export const S3_BUCKET = 'application-services-static-websites';
export const MEASUREMENT_ID = 'G-7636GJX23V';
export const SCORING_API_BASE_URL = 'https://appservices-uat.trustscience.com/scoring/v2';
export const LOGROCKET_APPID = false;
export const LOGROCKET_CHILD_DOMAINS = [];
export const USE_CHATBOT_LOCAL_FETCH_STRATEGY = false;
